module.exports = __webpack_public_path__ + "img/LOGO REPAHIS (BLANCO SIN FONDO).126778e8.png";